import React, { ReactElement, useContext, useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { Alert, Button, Layout, Menu } from 'antd';
import {
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  SmileOutlined,
  WechatOutlined,
  ApartmentOutlined,
  PieChartOutlined,
  SolutionOutlined,
  BookOutlined,
  FileTextOutlined,
  EditOutlined,
  BankOutlined,
  MessageOutlined,
  FundOutlined,
  SettingOutlined,
  DeploymentUnitOutlined,
} from '@ant-design/icons';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import CardBank from '../bank-components/CardBank';
import News from '../news/News';
import AdminBank from '../admin-bank/Adminbank';
import { ContextData } from '../../context/Data/ContextData';
import { getLogautApi } from '../api/api';
import AdminUsers from '../admin-users/AdminUsers';
import MainBlockChat from '../chatComponent/MainBlockChat';
import { ApiCenter } from '../api/ApiCenter';
import Education from '../Education/Education';
import CreatingTheme from '../Education/CreatingTheme/CreatingTheme';
import EducationComponent from '../Education/EducationComponent/EducationComponent';
import Theme from '../Education/Theme/Theme';
import EditTheme from '../Education/EditTheme/EditTheme';
import ThemeTestComponent from '../ThemeTest/ThemeTestComponent/ThemeTestComponent';
import ThemeTest from '../ThemeTest/ThemeTest';
import CreatingThemeTest from '../ThemeTest/CreatingThemeTest/CreatingThemeTest';
import { Roles } from '../../types/Types';
import TestQuestions from '../Education/TestQuestions/TestQuestions';
import EditThemeTest from '../ThemeTest/EditThemeTest/EditThemeTest';
import CreatingAttestation from '../ThemeTest/CreatingAttestation/CreatingAttestation';
import ChangeAttestation from '../ThemeTest/ChangeAttestation/ChangeAttestation';
import Attestation from '../Education/Attestation/Attestation';
import HrUsers from '../HrUsers/HrUsers';
import Departments from '../Departments/Departments';

const count_news: any = Number(localStorage.getItem('newsNotification'));

const icons: any = {
  FileTextOutlined: <FileTextOutlined />,
  BankOutlined: <BankOutlined />,
  UploadOutlined: <UploadOutlined />,
  MessageOutlined: <MessageOutlined />,
  BookOutlined: <BookOutlined />,
  UserOutlined: <UserOutlined />,
  EditOutlined: <EditOutlined />,
  DeploymentUnitOutlined: <DeploymentUnitOutlined />,
  FundOutlined: <FundOutlined />,
  SettingOutlined: <SettingOutlined />,
  VideoCameraOutlined: <VideoCameraOutlined />,
  SmileOutlined: <SmileOutlined />,
  WechatOutlined: <WechatOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  PieChartOutlined: <PieChartOutlined />,
  SolutionOutlined: <SolutionOutlined />,
};

const RenderBlock = () => {
  const { Content, Footer, Sider } = Layout;
  const { data, setData } = useContext(ContextData);
  const [dataRoles, setDataRoles] = useState(false);
  const [adminRole, setAdminRole] = useState(false);
  const [newsNotification, setNewsNotification] = useState(0);
  const [getMenuData, setMenuData] = useState<any[]>([]);
  const { HRNYA, SUPER_ADMIN, ADMIN } = Roles;
  const userRole = localStorage.getItem('role') as Roles;
  interface Elements {
    [key: string]: ReactElement;
  }
  const elements: Elements = {
    CardBank: <CardBank />,
    News: <News />,
    MainBlockChat: <MainBlockChat />,
    AdminBank: <AdminBank />,
    AdminUsers: <AdminUsers />,
    Education: <Education />,
    Tests: <ThemeTest />,
    HrUsers: <HrUsers />,
    Departments: <Departments />,
  };
  const getRoutesFromBack = () => {
    const api = new ApiCenter();
    api
      .authAxios('permissions')
      .then((res) => {
        if (!res.success) {
          localStorage.clear();
        } else {
          setMenuData(res.data.routes);
          localStorage.setItem('role', res.data.role);
        }
      })
      .catch((err) => localStorage.clear());
  };
  //const connectEchoi = () => {
  // echoi.options.auth.headers.Authorization = 'Bearer ' + localStorage.access_token;
  // console.log('echoi', echoi);
  // echoi
  //   .private('Messageptp.' + localStorage.id)
  //   // .channel('Messageptp.' + localStorage.id)
  //   .listen('PrivateChatEvent', (res: any) => {
  //     console.log('!!!!!!///////!!!!!!!', res);
  //     const message = res.data[0];
  //     let sender_name = 'Marketplace';
  //     if (message.sender_name != undefined) {
  //       sender_name = message.sender_name;
  //     }
  //     notification.info({
  //       message: message.content,
  //       description: 'От ' + sender_name,
  //       placement: 'bottomRight',
  //     });
  //     return;
  //     // console.log(window.location.pathname, '///////', sampleLocation);
  //     if (res.content[0].receiver_id === Number(localStorage.id)) {
  //       return;
  //     } else {
  //       if (window.location.pathname === '/chat') {
  //         setSocketMessage(res.content[0]);
  //       }
  //       notification.info({
  //         message: res.content[0].sender_name + ': ',
  //         description:
  //           res.content[0].content.length > 25
  //             ? res.content[0].content.slice(0, 25) + '...'
  //             : res.content[0].content,
  //         placement: 'bottomRight',
  //       });
  //     }
  //   })
  //   .error((err: any) => {
  //     console.log('err', err);
  //     if (err.type === 'AuthError') {
  //       alert('Уведомления перестали работать.\nПерезагрузите страницу');
  //     }
  //   })
  //   .subscribed(() => {
  //     console.log('PrivateChatEvent - ПОДПИСАН');
  //   });
  // echoi
  //   .channel('news')
  //   .listen('NotificationBankEvent', (res: any) => {
  //     console.log('NotificationBankEvent', res);
  //     notification.info({
  //       message: 'Изменения Банков',
  //       description: res.text_ws,
  //       placement: 'topRight',
  //     });
  //   })
  //   .error((err: any) => {
  //     console.log('err2', err);
  //   })
  //   .subscribed(() => {
  //     console.log('NotificationBankEvent - ПОДПИСАН');
  //   });
  //};
  //console.log('NotificationBankEvent', getMenuData);
  useEffect(() => {
    // connectEchoi();
    // Назначает роуты приложению в соответсвии с правами
    getRoutesFromBack();
    setNewsNotification(count_news);
    if (localStorage.role === '93160' || localStorage.role === '93260') {
      if (localStorage.role === '93160') {
        setAdminRole(true);
      }
      setDataRoles(true);
    } else {
      setDataRoles(false);
    }
    return () => {
      null;
    };
  }, []);
  const logautBtn = () => {
    getLogautApi();
    localStorage.removeItem('role');
    localStorage.removeItem('access_token');
    localStorage.removeItem('newsNotification');
    setData(false);
    window.location.reload();
  };

  // const resetNotif = () => {
  //   localStorage.setItem('newsNotification', '0');
  //   setNewsNotification(0);
  //   count_news = 0;
  // };
  // <SolutionOutlined />;
  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider breakpoint="xl" collapsedWidth="0">
          <div className="logo">
            <img
              src="https://static.tildacdn.com/tild3061-6639-4964-b664-353665643661/GCG.png"
              alt=""
              style={{ maxHeight: 50 }}
            />
          </div>
          {/* defaultSelectedKeys={['1']} */}
          <Menu theme="dark" mode="inline">
            {getMenuData.map((menu) => {
              return (
                <Menu.Item key={menu?.route?.key} icon={icons[menu?.route?.icon]}>
                  <Link to={menu.route.to}>{menu.route.content}</Link>
                </Menu.Item>
              );
            })}
          </Menu>
          <Button type="primary" onClick={logautBtn} style={{ marginLeft: 24, marginTop: 24 }}>
            Выход
          </Button>
        </Sider>
        <Layout>
          <Alert
            message="Коллеги! Заявки на Тендертех заводятся всегда вне зависимости от суммы, на ВБЦ  и Гособлако всегда от 5 млн."
            type="info"
            showIcon
            banner
            style={{ width: 'fit-content' }}
          />
          <Content style={{ margin: '0 24px' }}>
            <div className="site-layout-background" style={{ minHeight: 360, height: '100%' }}>
              <Routes>
                {getMenuData?.map((route) => {
                  const element = elements[route.route.element];
                  if (route.route.element === 'Education') {
                    if ([HRNYA, SUPER_ADMIN, ADMIN].includes(userRole)) {
                      return (
                        <Route key={route.route.key} path={route.route.to} element={element}>
                          <Route path={`creating-theme`} element={<CreatingTheme />} />
                          <Route path={`edit-theme/:id`} element={<EditTheme />} />
                          <Route path="theme/:id" element={<Theme />} />
                          <Route path="" element={<EducationComponent />} />
                          <Route path={`attestation`} element={<Attestation />} />
                        </Route>
                      );
                    }
                    return (
                      <Route key={route.route.key} path={route.route.to} element={element}>
                        <Route path="theme/:id" element={<Theme />} />
                        <Route path="" element={<EducationComponent />} />
                        <Route path="test-questions/:id" element={<TestQuestions />} />
                        <Route path={`attestation`} element={<Attestation />} />
                        <Route path={`departments`} element={<Departments />} />
                      </Route>
                    );
                  }
                  if (route.route.element === 'Tests') {
                    return (
                      <Route key={route.route.key} path={route.route.to} element={element}>
                        <Route path="" element={<ThemeTestComponent />} />
                        <Route path={`creating-test`} element={<CreatingThemeTest />} />
                        <Route path={`creating-test/:id`} element={<CreatingThemeTest />} />
                        <Route path={`edit-themeTest/:id`} element={<EditThemeTest />} />
                        {/* {EditThemeTest} */}
                        <Route path={`creating-attestation`} element={<CreatingAttestation />} />
                        <Route path={`edit-attestation/:id`} element={<ChangeAttestation />} />
                      </Route>
                    );
                  }
                  return <Route key={route.route.key} path={route.route.to} element={element} />;
                })}
              </Routes>
            </div>
          </Content>
          {/* <Footer style={{ textAlign: 'center' }}>
            <div style={{ padding: 10 }}>
              <img
                src="https://static.tildacdn.com/tild3061-6639-4964-b664-353665643661/GCG.png"
                alt=""
                style={{ maxHeight: 50 }}
              />
            </div>
            © Copyright {new Date().getFullYear()}. Все права защищены. Goszakaz Consulting Group
          </Footer> */}
        </Layout>
      </Layout>
    </>
  );
};

export default RenderBlock;
